let selectedPack = 0;
let selectedPrice = 0;

const BOX_VARIANTS = {

    10: 49023542952153,

    20: 49023542984921,

    30: 49023543017689

};

let pendingPack = 0;
let pendingPrice = 0;
let pendingCard = null;

let box = [];

const BuildYourBox = {

    init(){


    this.initQuantity();

    this.initCheckout();

    this.initRemoveItem();

},

    

    

   initQuantity() {

    console.log("initQuantity running");

    document.querySelectorAll('.qty-plus').forEach((button)=>{

        button.addEventListener('click',function(){

            if(selectedPack === 0){

    let message = document.querySelector(".box-message");

    message.innerHTML = "⚠️ Please choose your pack size first.";

    message.className = "box-message warning";
message.style.display = "block";

    setTimeout(function(){

        message.style.display = "none";

    },3000);

    return;

}

            let totalSelected = 0;

            document.querySelectorAll('.qty-input').forEach((qty)=>{

                totalSelected += parseInt(qty.value);

            });

           if(totalSelected >= selectedPack){

    let message = document.querySelector(".box-message");

    message.className = "box-message success";

    message.innerHTML = "✅ You have reached your selected pack size.";

    message.className = "box-message success";
message.style.display = "block";

    setTimeout(function(){

        message.style.display = "none";

    },3000);

    return;

}

            let input = this.parentElement.querySelector('.qty-input');

            input.value = parseInt(input.value) + 1;
            BuildYourBox.syncBox();

        });

    });

    document.querySelectorAll('.qty-minus').forEach((button)=>{

        button.addEventListener('click',function(){

            let input = this.parentElement.querySelector('.qty-input');

            if(parseInt(input.value) > 0){

                input.value = parseInt(input.value) - 1;
                BuildYourBox.syncBox();

            }

        });

    });

},
    
syncBox(){

    box = [];

    document.querySelectorAll('.build-your-box__product').forEach((product)=>{

        let quantity = parseInt(product.querySelector('.qty-input').value);

        if(quantity === 0) return;

        let selectedOption = {
    value: product.dataset.productId,
    text: ""
};

       box.push({

    productId: product.dataset.productId,

    productTitle: product.querySelector('h3').innerText,

    variantId: product.dataset.productId,

    variantTitle: "",

    quantity: quantity,

    unitPrice: 0,

    linePrice: 0

});

    });

    this.renderBox();

},

initAddToBox(){
        document.querySelectorAll('.add-to-box').forEach((button)=>{

            button.addEventListener('click',function(){

                let productCard = this.closest('.build-your-box__product');

let variant = productCard.querySelector('.variant-selector');

let quantity = productCard.querySelector('.qty-input');

let selectedOption = variant ? variant.options[variant.selectedIndex] : null;

let item = {

    productId: this.dataset.productId,

    productTitle: productCard.querySelector('h3').innerText,
    image: productCard.querySelector('img').src,

    variantId: variant ? variant.value : null,

    variantTitle: selectedOption ? selectedOption.text : '',

    quantity: parseInt(quantity.value),

    unitPrice: selectedOption ? parseInt(selectedOption.dataset.price) : 0,

linePrice: (selectedOption ? parseInt(selectedOption.dataset.price) : 0) * parseInt(quantity.value)

};

let existing = box.find(product =>

    product.variantId === item.variantId

);

if(item.quantity === 0){

    box = box.filter(product => product.variantId !== item.variantId);

}else if(existing){

    existing.quantity = item.quantity;

    existing.unitPrice = item.unitPrice;

    existing.linePrice = item.linePrice;

}else{

    box.push(item);

}

console.log(box);

BuildYourBox.renderBox();


            });

        });

    },

renderBox(){

    let container = document.querySelector('.box-items');

    if(!container) return;

    container.innerHTML = '';

    if(selectedPack > 0){

    container.innerHTML = `
        <div class="box-pack-header">

            Pack of ${selectedPack}

        </div>
    `;

}

if(box.length === 0){

    container.innerHTML = `
    <p class="empty-box">
        Your box is empty.
    </p>
`;

}else{

    box.forEach((item)=>{

        container.innerHTML += this.renderBoxItem(item);

    });

}
    this.updateSubtotal();
    this.updateCounter();

},

renderBoxItem(item){

    return `

        <div class="box-item">

            <div class="box-item-top">

                <span class="box-item-title">

                    ☕ ${item.productTitle}

                </span>

            </div>

            <div class="box-item-bottom">

                <span class="box-item-qty">

                    × ${item.quantity} Bags

                </span>

                <button
                    class="remove-item"
                    data-variant-id="${item.variantId}">

                    ✕ Remove

                </button>

            </div>

        </div>

    `;

},

updateSubtotal(){


    let subtotalElement = document.querySelector('.box-subtotal strong');

    if(!subtotalElement) return;

    subtotalElement.innerHTML = "$" + selectedPrice.toFixed(2);



},



updateCounter(){

    let totalBags = 0;

    box.forEach(item => {

        totalBags += item.quantity;

    });

    let counter = document.getElementById('selected-count');

    let pack = document.getElementById('selected-pack');

    let progress = document.querySelector('.progress-fill');
    let addButton = document.querySelector('.add-box-to-cart');

    if(counter){

        counter.innerHTML = totalBags;

    }

    if(pack){

        pack.innerHTML = selectedPack;

    }

    if(progress && selectedPack > 0){

        let percent = (totalBags / selectedPack) * 100;

        progress.style.width = percent + "%";

        let status = document.querySelector('.box-status');

        if(status){

    if(totalBags === selectedPack){

        if(addButton){

    addButton.disabled = false;

    addButton.innerHTML = "Add Box To Cart";

}

        progress.style.background =
            "linear-gradient(90deg,#4CAF50,#66BB6A)";

        status.innerHTML = "✅ Your box is ready!";

        status.style.display = "block";

    }else{

        if(addButton){

    addButton.disabled = true;

    let remaining = selectedPack - totalBags;

    if(selectedPack === 0){

        addButton.innerHTML = "Choose Your Pack";

    }else{

        addButton.innerHTML = `Select ${remaining} More Bag${remaining > 1 ? "s" : ""}`;

    }

}

        progress.style.background =
            "linear-gradient(90deg,#8b5e3c,#c58c55)";

        status.style.display = "none";

    }

}

    }

},


initCheckout(){

    let button = document.querySelector('.add-box-to-cart');

    if(!button) return;

    button.addEventListener('click', () => {

        this.addBoxToCart();

    });

},

initRemoveItem(){

    document.addEventListener('click',(event)=>{

        if(!event.target.classList.contains('remove-item')) return;

        let variantId = event.target.dataset.variantId;

        box = box.filter(item => item.variantId != variantId);

        this.renderBox();

    });

},

addBoxToCart(){


    let totalSelected = 0;

box.forEach(item => {

    totalSelected += item.quantity;

});

if(totalSelected !== selectedPack){

    let remaining = selectedPack - totalSelected;

    let message = document.querySelector('.box-message');

    if(message){

        if(remaining > 0){

            message.innerHTML =
                `Please select <strong>${remaining}</strong> more coffee bag(s).`;

        }else{

            message.innerHTML =
                `Please remove <strong>${Math.abs(remaining)}</strong> coffee bag(s).`;

        }

        message.style.display = 'block';

        setTimeout(function(){

            message.style.display = 'none';

        },3000);

    }

    return;

}

   if(box.length === 0){

    let message = document.querySelector('.box-message');

    if(message){

        message.innerHTML = '⚠️ Please select at least one product.';

        message.style.display = 'block';

        setTimeout(function(){

            message.style.display = 'none';

        },3000);

    }

    return;

}
/*
    let items = [];

    box.forEach(item => {

        items.push({

            id: item.variantId,

            quantity: item.quantity

        });

    });

    */

    let coffeeSelection = "";

box.forEach(item => {

    coffeeSelection +=
`☕ ${item.productTitle} ×${item.quantity}\n`;

});

let properties = {

    "Your Box":
`Pack of ${selectedPack}

${coffeeSelection}`

};

    console.log(properties);


let items = [

    {

        id: BOX_VARIANTS[selectedPack],

        quantity: 1,

        properties: properties

    }

];



    let message = document.querySelector('.box-message');

if(message){

    message.style.display = 'none';

}

    fetch('/cart/add.js',{

    method:'POST',

    headers:{

        'Content-Type':'application/json'

    },

    body:JSON.stringify({

    id: BOX_VARIANTS[selectedPack],

    quantity: 1,

    properties: properties

})

})
.then(response=>response.json())

.then(data=>{

    console.log(data);

    window.location = '/cart';

})


.catch(error=>{

    console.error(error);

});

}

};

const packCards = document.querySelectorAll(".pack-option");

packCards.forEach(card => {

    card.addEventListener("click", function () {

        // إذا كان هناك منتجات في الصندوق، أظهر رسالة التأكيد

        if(box.length > 0){

    pendingPack = Number(this.dataset.pack);

    pendingPrice = Number(this.dataset.price);

    pendingCard = this;

document.querySelector(".pack-warning").classList.add("show");

    return;

}

        // إعادة تعيين العدادات
        document.querySelectorAll(".qty-input").forEach(input => {

            input.value = 0;

        });

        // تفريغ الصندوق
        box = [];

        BuildYourBox.renderBox();

        packCards.forEach(c => c.classList.remove("active"));

        this.classList.add("active");

        selectedPack = Number(this.dataset.pack);

        selectedPrice = Number(this.dataset.price);

        BuildYourBox.updateSubtotal();

        BuildYourBox.updateCounter();

    });

});

BuildYourBox.init();

document.querySelector(".pack-cancel").addEventListener("click", function(){

    document.querySelector(".pack-warning").classList.remove("show");

});

document.querySelector(".pack-confirm").addEventListener("click", function(){

    // إخفاء الرسالة
    document.querySelector(".pack-warning").classList.remove("show");

    // تصفير جميع العدادات
    document.querySelectorAll(".qty-input").forEach(input => {

        input.value = 0;

    });

    // تفريغ الصندوق
    box = [];

    BuildYourBox.renderBox();

    // إزالة التحديد من جميع الباقات
    packCards.forEach(c => c.classList.remove("active"));

    // تحديد الباقة الجديدة
    pendingCard.classList.add("active");

    // حفظ الباقة الجديدة
    selectedPack = pendingPack;
    selectedPrice = pendingPrice;

    // تحديث الواجهة
    BuildYourBox.updateSubtotal();
    BuildYourBox.updateCounter();

});

